// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3UvA_","clinicsSelect":"TableHeading_clinicsSelect__1ERoZ"};